import { Tax } from '../modules/Taxes/Model';
import Extra from '../modules/Extras/Extra';
export class PriceExtra {
    constructor(values) {
        this.id = values.id;
        this.name = values.name;
        this.price = values.price;
        this.description = values.description;
        this.isIncluded = values.isIncluded;
        if (values.tax) {
            this.tax = new Tax(values.tax);
        }
        else {
            throw new Error('tax not found');
        }
        if (values.extra) {
            this.extra = new Extra(values.extra);
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/Models/PriceExtra.ts
// module id = 360
// module chunks = 0